import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from '../../../services/web-api-service';
import { BusyService } from '../../../services/busy-service';
import { CarrierRequirementExemptionDialogParams } from './carrier-requirement-exemption-dialog-params';

@autoinject
export class CarrierRequirementExemptionDialog {
    public context: CarrierRequirementExemptionDialogParams;
    public dialogTitle: string;

    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private busyService: BusyService) {
    }

    public submitted = false;
    public exemptionComment = "";

    async activate(params) {
        this.context = params as CarrierRequirementExemptionDialogParams;
        if (this.context.carrierMasterApprovalRequirementId) {
            this.dialogTitle = "Edit exemption";
        } else {
            this.dialogTitle = "Add new exemption";
        }
    }

    public async save(){
        this.submitted = true;
        if( this.exemptionComment){
            var exemption = {
                carrierMasterApprovalRequirementId: this.context.carrierMasterApprovalRequirementId,
                exemptionComment: this.exemptionComment
            };
            await this.api.post("Carriers", "AddNewRequirementExcemption", exemption);
            this.controller.ok(true);
        }
    }
}